import Settings from 'src/Settings';
import BaseDescriptor from './disclaimerScreen-redesign';
import CanteenDescriptor from './disclaimerScreen-canteen';
import {createTypeDescriber} from 'src/utils/DescriptorUtils';

const typeDescriber = createTypeDescriber(BaseDescriptor);

typeDescriber.canteen = CanteenDescriptor;
typeDescriber.companykitchen = CanteenDescriptor;

export function getDescriber() {
  return typeDescriber[Settings.buildType];
}
